'use client';

import { HStack } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';
import { HITLStatusIndicator } from '../../HITLStatusIndicator';
import type { CardRenderContext } from '../../tool-config-types';
import { getGuardrailReasonHeaderAction } from './guardrail-reason-header-action';

export function getHITLArtifactHeaderActions({
  hitlDecisionType,
  headerActions,
  toolCallData,
}: Pick<
  CardRenderContext,
  'hitlDecisionType' | 'headerActions' | 'toolCallData'
>): ReactNode {
  const statusIndicator = hitlDecisionType ? (
    <HITLStatusIndicator status={hitlDecisionType} />
  ) : null;
  const guardrailAction = getGuardrailReasonHeaderAction(toolCallData.input);

  if (!headerActions && !statusIndicator && !guardrailAction) {
    return undefined;
  }

  return (
    <HStack gap={1} alignItems="center">
      {statusIndicator}
      {headerActions}
      {guardrailAction}
    </HStack>
  );
}

export function getHITLLeadingHeaderActions({
  hitlDecisionType,
  headerActions,
}: Pick<CardRenderContext, 'hitlDecisionType' | 'headerActions'>): ReactNode {
  const statusIndicator = hitlDecisionType ? (
    <HITLStatusIndicator status={hitlDecisionType} />
  ) : null;

  if (!headerActions && !statusIndicator) {
    return undefined;
  }

  return (
    <HStack gap={1} alignItems="center">
      {statusIndicator}
      {headerActions}
    </HStack>
  );
}
